import dynamic from "next/dynamic";

export const DynamicContent040 = dynamic(() => import("./Content040"), {
  suspense: true,
});
